const TrackPlayer = {
  setupPlayer: async () => {},
  updateOptions: async () => {},
  registerPlaybackService: () => {},
  getActiveTrack: async () => null,
  getTrack: async () => null,
  getPlaybackState: async () => ({ state: State.None }),
  add: async () => {},
  reset: async () => {},
  play: async () => {},
  pause: async () => {},
  skip: async () => {},
  skipToNext: async () => {},
  skipToPrevious: async () => {},
  setRate: async () => {},
  seekTo: async () => {},
};

export const State = {
  None: 'none',
  Playing: 'playing',
  Paused: 'paused',
  Buffering: 'buffering',
  Loading: 'loading',
  Connecting: 'connecting',
};

export const Event = {
  PlaybackActiveTrackChanged: 'playback-active-track-changed',
};

export const Capability = {
  Play: 'play',
  Pause: 'pause',
  SkipToNext: 'skipToNext',
  SkipToPrevious: 'skipToPrevious',
  SeekTo: 'seekTo',
};

export const AppKilledPlaybackBehavior = {
  ContinuePlayback: 'continue-playback',
};

export const RepeatMode = {
  Off: 'off',
  Track: 'track',
  Queue: 'queue',
};

export const usePlaybackState = () => ({ state: State.None });
export const useProgress = () => ({ position: 0, duration: 0, buffered: 0 });
export const useTrackPlayerEvents = () => {};

export default TrackPlayer;
